import { useAuth } from '@/contexts/AuthContext';
import Spinner from '@/components/ui/Spinner';
import CoachDashboard from './CoachDashboard';
import AthleteDashboard from './AthleteDashboard';

/**
 * Dashboard — role-routing entry point.
 *
 * Coaches and admins see the full Coach Dashboard (analytics, charts, template grid).
 * Athletes (and any unrecognized role) see the generic AthleteDashboard.
 */
function Dashboard() {
  const { user, isLoading } = useAuth();

  // B-2026-0024 #10: while auth is resolving (or user is briefly null), show a
  // spinner instead of flashing AthleteDashboard to coaches on cold load.
  if (isLoading || !user) {
    return (
      <div className="flex items-center justify-center py-24">
        <Spinner size="lg" label="Loading dashboard…" />
      </div>
    );
  }

  if (user.role === 'coach' || user.role === 'admin') {
    return <CoachDashboard />;
  }

  return <AthleteDashboard />;
}

export default Dashboard;
